import styled from "styled-components/native";

const SiteWrap = styled.View`
  background: #effaff;
  height: 100vh;
  width: 100%;
`;

export default SiteWrap;



// WEBPACK FOOTER //
// ./src/components/SiteWrap/SiteWrap.js